// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"22381604","383":"fed6d684","626":"c8708682"}[chunkId] + ".chunk.css";
};